/**
 * Get phone number from JID
 * @param jid - JID (remote JID)
 * @returns Phone number with + prefix or the raw number from JID
 */
export function phoneNumberFromJid(jid: string): string {
  const numberPart = jid.split('@')[0];

  // For individual WhatsApp contacts, add + prefix
  if (jid.endsWith('@s.whatsapp.net')) {
    return `+${numberPart}`;
  }

  // For groups, channels, and other formats, return raw number
  return numberPart;
}
